/* Shared "open chat" helper for Help Center CTAs (hub, Troubleshooting, Contact).
   Tidio is installed via a Shopify app, not this theme, so its script tag
   and window.tidioChatApi load asynchronously and may not be ready yet when
   a visitor clicks. Retries briefly, then falls back to mailto so the
   button never just does nothing. */
(function () {
  function openTidio(fallbackHref) {
    var attempts = 0;
    var maxAttempts = 10;

    function tryOpen() {
      if (window.tidioChatApi && typeof window.tidioChatApi.open === 'function') {
        window.tidioChatApi.open();
        return;
      }
      attempts += 1;
      if (attempts >= maxAttempts) {
        if (fallbackHref) window.location.href = fallbackHref;
        return;
      }
      setTimeout(tryOpen, 300);
    }

    tryOpen();
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-je-open-chat]');
    if (!trigger) return;
    e.preventDefault();
    openTidio(trigger.getAttribute('data-je-chat-fallback') || trigger.getAttribute('href'));
  });
})();
